/*
 * Author: harper
 * File Created: Friday, 24-07-05 03:48 pm
 * Last Modified: Monday, 25-03-17 06:24 pm, by Harper Yan
 */

import { useTranslation } from 'next-i18next';

import { Icon } from '@ucard/ds/Icon';
import { useScreenSize } from '@ucard/ds/utils';

import TgBotIcon from '@/components/FixedContactor';
import LandingContainer from '@/components/LandingContainer';
import { getStaticLocaleProps } from '@/utils/i18n';

import Card from './_modules/Card';
import Hero from './_modules/Hero';
import Payments from './_modules/Payments';
import Products from './_modules/Products';

export default function Page() {
  const isXsScreen = useScreenSize('xs');
  const { t } = useTranslation('common');

  const handleServiceClick = () => {
    // todo
    window.open('https://t.me/TheDeHelpBot', '_blank');
  };

  return (
    <LandingContainer
      meta={{ title: 'DeCard' }}
      sx={{
        background: `linear-gradient(#030303 0%, #242633 25%, #1e1e1e 100%)`,
      }}>
      <Hero />
      <Card />
      <Products />
      <Payments />
      {!isXsScreen && (
        <TgBotIcon
          bottom={30}
          expandText={t('tgbot')}
          icon={<Icon name="Contact" sx={{ width: '28px', height: '28px' }} />}
          onClick={handleServiceClick}
        />
      )}
    </LandingContainer>
  );
}

export const getStaticProps = getStaticLocaleProps(['home']);
